<template>
  <div class="page-container cash-register-moved">
    <portal to="page-name">Caixa</portal>
    <div class="card card-page">
      <div class="card-body">
        <div class="empty">
          <div class="empty-icon">
            <fa-icon :icon="['fal', 'cash-register']" size="3x"/>
          </div>
          <p class="empty-title h5">O caixa mudou de lugar</p>
          <p class="empty-subtitle">
            Agora ele fica na barra superior, ao lado da busca. O ícone mostra um ponto verde
            quando o seu caixa está aberto, e você pode abrir de qualquer tela do sistema.
          </p>
          <div class="cr-moved-hint">
            <fa-icon :icon="['fal', 'arrow-up']" class="mr-1"/>
            Procure o ícone
            <span class="cr-moved-icon"><fa-icon :icon="['fal', 'cash-register']"/></span>
            no canto superior direito
          </div>
          <div class="empty-action">
            <router-link to="/cash-register" class="btn btn-primary btn-icon btn-icon-left">
              <fa-icon :icon="['fal', 'cash-register']"/>Acessar meu caixa
            </router-link>
          </div>
          <div class="cr-moved-legacy">
            Precisa consultar ou fechar um caixa do modelo anterior?
            <router-link to="/cashier-opening">Abrir o caixa antigo</router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss">
@import "./src/assets/scss/_variables.scss";
.cash-register-moved {
  .empty {
    padding: $layout-spacing-xl;
  }
  .empty-subtitle {
    margin: 0 auto $layout-spacing;
    max-width: 32rem;
  }
  .cr-moved-legacy {
    color: $gray-color-dark;
    font-size: $font-size-sm;
    margin-top: $layout-spacing-lg;
    a {
      font-weight: 600;
      margin-left: .2rem;
    }
  }
  .cr-moved-hint {
    color: $gray-color-dark;
    font-size: $font-size-sm;
    margin-bottom: $layout-spacing-lg;
    .cr-moved-icon {
      background-color: $gray-color-ultra-light;
      border: $border-color solid $border-width;
      border-radius: $border-radius;
      display: inline-block;
      margin: 0 .3rem;
      padding: .1rem .35rem;
    }
  }
}
</style>
